const FormContext = React.createContext(null);
export function FormProvider({ form, children }) {
    return (React.createElement(FormContext.Provider, { value: form }, children));
}
export function useForm() {
    const form = React.useContext(FormContext);
    return form;
}
